import React from 'react';
export default function EmptyContainer(props){
    return <div className="empty-summary-container">
    {props.children}
  </div>
}